import React from 'react';
import { Phone, MapPin, Building } from 'lucide-react';

const ContactPage = () => {
  const departments = [
    {
      id: 1,
      department: "Water Resources Department",
      waterBodies: "14,307",
      contactPerson: "The Engineer-in-Chief, WRD",
      phone: "044-28525351"
    },
    {
      id: 2,
      department: "Rural Development and Panchayat Raj",
      waterBodies: "74,234",
      contactPerson: "",
      phone: ""
    },
    {
      id: 3,
      department: "Town Panchayat",
      waterBodies: "2,248",
      contactPerson: "The Director of Town Panchayat",
      phone: "044-29520050"
    },
    {
      id: 4,
      department: "Municipal Administration",
      waterBodies: "583",
      contactPerson: "",
      phone: ""
    },
    {
      id: 5,
      department: "Greater Chennai Corporation",
      waterBodies: "206",
      contactPerson: "",
      phone: ""
    },
    {
      id: 6,
      department: "Environment, Climate Change & Forest",
      waterBodies: "1,294",
      contactPerson: "",
      phone: ""
    },
    {
      id: 7,
      department: "Hindu Religious & Charitable Endowment",
      waterBodies: "2,465",
      contactPerson: "",
      phone: ""
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-amber-50 via-orange-50 to-yellow-50">
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap');
        
        .contact-font {
          font-family: 'Inter', system-ui, sans-serif;
        }
        
        body, html {
          margin: 0;
          padding: 0;
          min-height: 100vh;
        }
      `}</style>
      
      <section className="py-36 contact-font">
        <div className="container mx-auto px-6 lg:px-8 max-w-6xl">
          
          {/* Header */}
          <div className="text-center mb-12">
            <h1 className="text-3xl lg:text-4xl font-semibold text-slate-800 mb-4">
              Department Directory
            </h1>
            <p className="text-slate-600 text-lg max-w-2xl mx-auto">
              Contact information for waterbody management departments across Tamil Nadu
            </p>
          </div>

          {/* Departments Table */}
          <div className="bg-amber-50 rounded-2xl border-2 border-orange-200 p-8 shadow-xl">
            <h2 className="text-xl font-semibold text-slate-800 mb-6">
              Department Information
            </h2>
            
            {/* Table Header */}
            <div className="overflow-x-auto">
              <div className="min-w-full">
                
                {/* Header Row */}
                <div className="grid grid-cols-12 gap-4 p-4 bg-orange-100 border-2 border-orange-200 rounded-xl mb-4 font-medium text-slate-800">
                  <div className="col-span-1 text-center">S.No</div>
                  <div className="col-span-5">Department</div>
                  <div className="col-span-2 text-center">No. of Water Bodies</div>
                  <div className="col-span-4">Contact Person</div>
                </div>

                {/* Data Rows */}
                <div className="space-y-3">
                  {departments.map((dept) => (
                    <div 
                      key={dept.id}
                      className="grid grid-cols-12 gap-4 p-4 bg-orange-50 border-2 border-orange-200 rounded-xl hover:bg-orange-100 transition-colors duration-200"
                    >
                      <div className="col-span-1 text-center">
                        <span className="w-6 h-6 bg-gradient-to-r from-amber-600 to-orange-600 rounded-full flex items-center justify-center text-white text-xs font-medium mx-auto">
                          {dept.id}
                        </span>
                      </div>
                      
                      <div className="col-span-5">
                        <div className="flex items-start space-x-2">
                          <Building size={16} className="text-slate-500 mt-0.5 flex-shrink-0" />
                          <span className="text-slate-800 font-medium text-sm">
                            {dept.department}
                          </span>
                        </div>
                      </div>
                      
                      <div className="col-span-2 text-center">
                        <span className="text-slate-700 font-semibold">
                          {dept.waterBodies}
                        </span>
                      </div>
                      
                      <div className="col-span-4">
                        {dept.contactPerson ? (
                          <div className="space-y-1">
                            <div className="flex items-start space-x-2">
                              <MapPin size={14} className="text-slate-500 mt-0.5 flex-shrink-0" />
                              <span className="text-slate-700 text-sm">
                                {dept.contactPerson}
                              </span>
                            </div>
                            {dept.phone && (
                              <div className="flex items-center space-x-2">
                                <Phone size={14} className="text-slate-500 flex-shrink-0" />
                                <span className="text-slate-600 text-sm">
                                  {dept.phone}
                                </span>
                              </div>
                            )}
                          </div>
                        ) : (
                          <span className="text-slate-400 text-sm italic">
                            Contact details not available
                          </span>
                        )}
                      </div>
                    </div>
                  ))}
                </div>

              </div>
            </div>
          </div>



        </div>
      </section>
    </div>
  );
};

export default ContactPage;